<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import Pager from "./Pager.vue";
const idx = ref(0);
const mql = window.matchMedia("(max-width: 834px)");
const startX = ref(0);
const endX = ref(0);

const props = defineProps({
    length: {
        type: Number,
        required: true,
    },
    items: {
        type: Array,
        required: true,
    },
    classNames: {
        type: Array,
        default: () => [],
    },
});

const handleTouchStart = (event) => {
    if (!mql.matches) return;
    if (props.length <= 1) return;
    startX.value = event.touches[0].clientX;
};

const handleTouchEnd = (event) => {
    if (!mql.matches) return;
    if (props.length <= 1) return;
    endX.value = event.changedTouches[0].clientX;
    if (startX.value - endX.value > 50) {
        idx.value = (idx.value + 1) % props.length;
    } else if (endX.value - startX.value > 50) {
        idx.value = (idx.value - 1 + props.length) % props.length;
    }
};

onMounted(() => {
    if (!props.items || props.items.length === 0) {
        document.body.classList.add("-bnr-no-items");
        return;
    }

    const interval = setInterval(() => {
        idx.value = (idx.value + 1) % props.length;
    }, 5000);

    onUnmounted(() => {
        clearInterval(interval);
    });
});
</script>

<template>
    <div v-if="items && items.length > 0" :class="classNames" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
        <div class="c-slider" :style="{ transform: `translateX(-${idx * 100}%)` }">
            <div v-if="items[0].scene_image" class="c-slider__item" v-for="(item, idx) in items" :key="idx">
                <img :src="item.scene_image" alt="" />
            </div>
            <a v-else-if="items[0].banner_image" :href="item.link.url" :target="item.link.target" class="c-slider__item" v-for="(item, idxThumb) in items" :key="idxThumb">
                <img :src="item.banner_image.url" alt="" />
            </a>
        </div>
    </div>
    <Pager v-if="items && items.length > 0" v-model="idx" :length="length"></Pager>
</template>
